module.exports = __webpack_public_path__ + "img/1232q.fb94b06b.png";